import { gsap, Power0, Power1, Power2, Power3, Power4, Linear, Quad, Cubic, Quart, Quint, Strong, Back, Bounce, Circ, Elastic, Expo, Sine } from 'gsap';

// --- REVSLIDER COMPATIBILITY: FILTER EMPTY TARGETS ---
// Revolution Slider 5.x often passes empty jQuery objects to GSAP.
// GSAP 2 silently ignored them, but GSAP 3 warns. This restores GSAP 2 behavior.
const originalTo = gsap.to;
const originalFrom = gsap.from;
const originalFromTo = gsap.fromTo;
const originalSet = gsap.set;

const isInvalidTarget = (target) => {
    return (target && target.jquery && target.length === 0);
};

gsap.to = function (target, vars) {
    if (isInvalidTarget(target)) return null;
    return originalTo.apply(gsap, arguments);
};
gsap.from = function (target, vars) {
    if (isInvalidTarget(target)) return null;
    return originalFrom.apply(gsap, arguments);
};
gsap.fromTo = function (target, fromVars, toVars) {
    if (isInvalidTarget(target)) return null;
    return originalFromTo.apply(gsap, arguments);
};
gsap.set = function (target, vars) {
    if (isInvalidTarget(target)) return null;
    return originalSet.apply(gsap, arguments);
};
// --- END COMPATIBILITY ---

// Polyfill for Revolution Slider which expects GSAP 2 style punchgs object
window.punchgs = window.punchgs || {};

const extendTimeline = (tl) => {
    tl.getLabelTime = function (label) {
        return this.labels[label];
    };
    return tl;
}

const TimelineFactory = function (vars) {
    return extendTimeline(gsap.timeline(vars));
};

const gsClasses = {
    TweenLite: gsap,
    TweenMax: gsap,
    TimelineLite: TimelineFactory,
    TimelineMax: TimelineFactory,
    Power0, Power1, Power2, Power3, Power4,
    Linear, Quad, Cubic, Quart, Quint, Strong,
    Back, Bounce, Circ, Elastic, Expo, Sine
};

Object.keys(gsClasses).forEach(key => {
    // We overwrite or set if missing. Overwriting is safer if the existing one is broken.
    if (!window.punchgs[key]) {
        window.punchgs[key] = gsClasses[key];
    }
});

// Also expose globally if needed by some scripts
window.TweenLite = window.TweenLite || gsap;
window.TweenMax = window.TweenMax || gsap;

// Polyfill lagSmoothing for GSAP 3
if (!window.punchgs.TweenLite.lagSmoothing) {
    window.punchgs.TweenLite.lagSmoothing = function (threshold, adjustedLag) {
        gsap.ticker.lagSmoothing(threshold, adjustedLag);
    };
}
if (!window.punchgs.TweenLite.killDelayedCallsTo) {
    window.punchgs.TweenLite.killDelayedCallsTo = function (func) {
        gsap.killTweensOf(func);
    };
}

if (!window.TweenLite.lagSmoothing) {
    window.TweenLite.lagSmoothing = function (threshold, adjustedLag) {
        gsap.ticker.lagSmoothing(threshold, adjustedLag);
    };
}
if (!window.TweenLite.killDelayedCallsTo) {
    window.TweenLite.killDelayedCallsTo = function (func) {
        gsap.killTweensOf(func);
    };
}

// Polyfill ticker for GSAP 3 (Revolution Slider utilizes this)
if (gsap.ticker && !gsap.ticker.addEventListener) {
    gsap.ticker.addEventListener = function (type, callback) {
        if (type === "tick") {
            gsap.ticker.add(callback);
        }
    };
}

if (gsap.ticker && !gsap.ticker.removeEventListener) {
    gsap.ticker.removeEventListener = function (type, callback) {
        if (type === "tick") {
            gsap.ticker.remove(callback);
        }
    };
}

